//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import UserModel from '@/models/General/GUser'
import fields from './fields'

//
export default {
    name: 'user-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {

        fieldsProps() {
            return {
                g_selected_roles_trigger: this.submit,
                g_user_id: this.formData.id,
            }
        },

        /**
         * 
         */
        formProps () {
            return {
                editable: false,
                fields: fields(this.fieldsProps),
                loading: this.formLoading,
                switchEdit: true,
                title: this.formTitle,
            }
        },

        /**
         * 
         */
        formTitle() {
            return `usuario #${this.$route.params.id}`
        },

        /**
         * 
         */
        viewTitle() {
            return `Detalle de ${this.formTitle}`
        },
    },
    data () {
        return {
            formLoading: false,
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( 'MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( UserModel, error.response.data ) )
        },

        /**
         * Fetches a suggest auth code.
         *
         * @return     {<type>}  The suggest auth code.
         */
        fetchSuggestAuthCode() {
            return this.formData.fetchSuggestAuthCode()
        },

        /**
         * Fetches a suggest bar auth code.
         *
         * @return     {<type>}  The suggest bar auth code.
         */
        fetchSuggestBarAuthCode() {
            return this.formData.fetchSuggestBarAuthCode()
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: 'user-list' })
        },

        /**
         * 
         */
        refresh () {
            this.reset()
        },

        /**
         * 
         */
        reset () {
            this.formLoading = true
            UserModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
            this.formLoading = false
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitSuggestAuthCode() {
            return this
                .toWait(true)
                .then(this.fetchSuggestAuthCode)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitSuggestBarAuthCode() {
            return this
                .toWait(true)
                .then(this.fetchSuggestBarAuthCode)
                .then(this.toWait)
        },

        /**
         * 
         */
        success () {
            this.$toast.success( 'Usuario actualizado.' )
        },

        /**
         * @description
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },

        /**
         * 
         */
        update ( model ) {
            model.toUpdate().save().then( this.success ).then( this.refresh ).catch( this.error ).then( this.$refs.form.setWait )
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: this.viewTitle })
    },
    mounted () {
        this.reset()
    }
}